function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M64,45.732318 L64,45.9216696 C63.9867143,52.1304591 63.3261981,54.4110256 62.0966795,56.7100256 C60.8547415,59.0322479 59.0322479,60.8547415 56.7100256,62.0966795 C54.4110256,63.3261981 52.1304591,63.9867143 45.9216696,64 L45.732318,64 L18.267682,64 L18.0783304,64 C11.8695409,63.9867143 9.58897436,63.3261981 7.28997436,62.0966795 C4.96775214,60.8547415 3.14525855,59.0322479 1.90332051,56.7100256 L1.83023282,56.5720762 C0.659707378,54.3412301 0.0260284787,52.0534599 -5.68434189e-14,46.1067587 L-5.68434189e-14,45.9216696 L-5.68434189e-14,18.0783304 C0.0132857051,11.8695409 0.67380186,9.58897436 1.90332051,7.28997436 C3.14525855,4.96775214 4.96775214,3.14525855 7.28997436,1.90332051 L7.42792382,1.83023282 C9.6587699,0.659707378 11.9465401,0.0260284787 17.8932413,0 L18.0783304,0 L45.9216696,0 C52.1304591,0.0132857051 54.4110256,0.67380186 56.7100256,1.90332051 C59.0322479,3.14525855 60.8547415,4.96775214 62.0966795,7.28997436 C63.3261981,9.58897436 63.9867143,11.8695409 64,18.0783304 L64,18.267682 L64,45.732318 Z",
  id: "path-1"
}), React.createElement("filter", {
  x: "-10.2%",
  y: "-8.6%",
  width: "120.3%",
  height: "120.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Main-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "About-_-Modal-View",
  transform: "translate(-151.000000, -821.000000)"
}, React.createElement("g", {
  id: "View",
  transform: "translate(0.000000, 190.000000)"
}, React.createElement("g", {
  id: "Item",
  transform: "translate(24.000000, 634.000000)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(131.000000, 0.000000)"
}, React.createElement("g", {
  id: "Path"
}, React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})), React.createElement("g", {
  id: "ic_",
  transform: "translate(16.000000, 16.000000)"
}, React.createElement("g", {
  id: "Icon",
  transform: "translate(0.000000, 1.000000)",
  fill: "#FFAD2F"
}, React.createElement("path", {
  d: "M32,19.6923077 L32,17.2307692 C32,15.1913846 30.3470769,13.5384615 28.3076923,13.5384615 L3.69230769,13.5384615 C1.65292308,13.5384615 0,15.1913846 0,17.2307692 L0,19.6923077 L32,19.6923077 Z",
  id: "Fill-1"
}), React.createElement("polygon", {
  id: "Fill-3",
  points: "0 22.1538462 0 28.3076923 3.69230769 28.3076923 3.69230769 24.6153846 28.3076923 24.6153846 28.3076923 28.3076923 32 28.3076923 32 22.1538462"
}), React.createElement("path", {
  d: "M29.0366769,4.2464 C21.2717538,-1.41513846 10.7277538,-1.41513846 2.96283077,4.2464 C2.64529231,4.47778462 2.46190769,4.85563077 2.46190769,5.24824615 L2.46190769,9.8464 L4.92344615,9.8464 L4.92344615,8.92578462 C4.92344615,7.56578462 6.02498462,6.46424615 7.38498462,6.46424615 L12.3080615,6.46424615 C13.6668308,6.46424615 14.7696,7.56578462 14.7696,8.92578462 L14.7696,9.8464 L17.2311385,9.8464 L17.2311385,8.92578462 C17.2311385,7.56578462 18.3326769,6.46424615 19.6926769,6.46424615 L24.6157538,6.46424615 C25.9745231,6.46424615 27.0772923,7.56578462 27.0772923,8.92578462 L27.0772923,9.8464 L29.5388308,9.8464 L29.5388308,5.24824615 C29.5388308,4.85563077 29.3542154,4.47778462 29.0366769,4.2464",
  id: "Fill-5"
})), React.createElement("g", {
  id: "Icon",
  transform: "translate(20.000000, 17.000000)"
}, React.createElement("rect", {
  id: "icon",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  rx: 10
}), React.createElement("path", {
  d: "M10,2 C14.418278,2 18,5.581722 18,10 C18,14.418278 14.418278,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 Z",
  id: "icon",
  fill: "#FFE72E"
}), React.createElement("g", {
  id: "ic_check",
  transform: "translate(6.000000, 7.102944)",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M7.7254834,0.234314575 C8.03790283,0.546734008 8.03790283,1.05326599 7.7254834,1.36568542 L3.2,5.89116882 C2.88758057,6.20358826 2.38104858,6.20358826 2.06862915,5.89116882 L2.0337592,5.8523487 C1.99785028,5.82678137 1.96357904,5.79789361 1.93137085,5.76568542 L0.234314575,4.06862915 C-0.0781048584,3.75620972 -0.0781048584,3.24967773 0.234314575,2.9372583 C0.546734008,2.62483887 1.05326599,2.62483887 1.36568542,2.9372583 L2.628,4.2 L6.59411255,0.234314575 C6.90653198,-0.0781048584 7.41306397,-0.0781048584 7.7254834,0.234314575 Z",
  id: "Path"
})))))))));

var SvgPic2 = function SvgPic2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPic2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pic_2.4ca74abd.svg";
export { ForwardRef as ReactComponent };